var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMn(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#da2032",
    d: "M0 0h53.3v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0066b3",
    d: "M17.8 0h17.8v40H17.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd900",
    d: "M8.9 18.5a3.3 3.3 0 1 0 0-6.7 3.3 3.3 0 0 0 0 6.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#da2032",
    d: "M8.9 17.3a3.6 3.6 0 1 0 0-7.3 3.6 3.6 0 0 0 0 7.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd900",
    d: "M8.9 16.7a2.4 2.4 0 1 0 0-4.9 2.4 2.4 0 0 0 0 4.9m.2-10.3-.4.6v.6l-.3 1 .2.8q0 .3-.3.3L8 9.4v-.2h.1l.2-.3-.3-.4.2-.6q-.4.2-.5.5v.5l-.3.3-.1.5a1.5 1.5 0 0 0 3 0l-.2-.5L10 9v-.5L9.5 8q.3.4.1.6v.7h.1l.1.2-.3.3q-.3 0-.3-.3c0-.6.2-.6.2-1 0-.7-.5-1-.5-1.4zM2.2 19h3v14.5h-3zm10.3 0h3v14.5h-3zM6 19h6l-3 1.8zm0 2.4h6v1.2H6zm0 8.5h6v1.2H6zm0 1.8h6l-3 1.8zm2.9-2.3a3 3 0 1 0 0-6 3 3 0 0 0 0 6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#da2032",
    d: "M8.9 25.4a.6.6 0 1 0 0-1.3.6.6 0 0 0 0 1.3m0 3.2a.6.6 0 1 0 0-1.2.6.6 0 0 0 0 1.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#da2032",
    d: "M8.9 23a1.8 1.8 0 0 1 0 3.5 1.4 1.4 0 1 0 0 2.9v.4a1.8 1.8 0 0 1 0-3.6 1.4 1.4 0 0 0 0-2.9z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h53.3v40H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMn);
export default __webpack_public_path__ + "static/media/mn.dedf3d9b063bd4008afa085ff4a01199.svg";
export { ForwardRef as ReactComponent };